import SubBrandPage from "@/components/SubBrandPage";

const BAR_FOOTNOTE = "Client provides alcohol and ice. Includes up to 3 signature cocktails.";

export default function TheSocialBar() {
  return (
    <SubBrandPage meta={{
      slug: "social-bar",
      tag: "Sip",
      title: "The Social Bar.",
      tagline: "Elevated drinks. Unforgettable vibes.",
      heroImg: "/media/social-bar.jpg",
      overview: "We bring the bar. You create the memories. Pro bartenders, custom menus, and every detail styled to match your event.",
      ctaLabel: "Book The Social Bar",
      packages: [
        {
          name: "The Social Sip", price: 250, meta: "Up to 20 guests · Up to 2 hours",
          includes: [
            "Professional bartender",
            "Complete bar setup",
            "Bar tools & equipment",
            "Mixers & juices",
            "Standard syrups",
            "Fresh garnishes",
            "Dehydrated garnishes",
            "Custom drink menu",
            "All bar essentials (cups, straws, napkins & cocktail picks)",
            "Setup & cleanup",
          ],
          footnote: BAR_FOOTNOTE,
        },
        {
          name: "The Social Pour", price: 450, meta: "Up to 50 guests · Up to 4 hours",
          includes: [
            "Everything in The Social Sip",
            "Expanded service for larger events",
          ],
          footnote: BAR_FOOTNOTE,
        },
        {
          name: "The Social Experience", price: 550, meta: "Up to 75 guests · Up to 4 hours",
          includes: [
            "Everything in The Social Pour, plus:",
            "Premium syrups",
            "Dehydrated garnishes",
            "Custom bottle labels",
            "Custom cup labels",
            "Coordinated themed bar presentation",
          ],
          footnote: BAR_FOOTNOTE,
        },
        {
          name: "The Social Reserve", price: 850, meta: "Up to 125 guests · Up to 5 hours",
          includes: [
            "Everything in The Social Experience, plus:",
            "Two professional bartenders",
            "Premium syrups",
            "Priority planning consultation",
            "Expedited service for larger guest counts",
            "Premium bar styling",
          ],
          footnote: BAR_FOOTNOTE,
        },
      ],
      pricingNote: "All Social Bar prices start at the amounts listed. Client provides alcohol and ice on every package.",
      addons: [
        { name: "Additional hour", price: "$100 / hr" },
        { name: "Additional bartender", price: "$250" },
        { name: "Additional signature cocktail", price: "$25 / drink" },
        { name: "Travel (first 30 miles included)", price: "$1.25 / mile" },
      ],
      sections: [],
      faqs: [
        { q: "Do you provide the alcohol?", a: "No — the client provides alcohol and ice on every package. We handle everything else, and we'll send you a full shopping list based on your final menu and guest count." },
        { q: "Are your bartenders licensed?", a: "Yes. Every Simply Social bartender is professionally trained and licensed to serve." },
        { q: "How far in advance should I book?", a: "For weekend events, 6–10 weeks out is ideal. Rush bookings are possible depending on availability." },
        { q: "Do you travel?", a: "We serve Chicago, St. Louis, and surrounding areas. First 30 miles are included; additional travel is $1.25 per mile round-trip. St. Louis-area events include a $75 travel fee." },
      ],
    }} />
  );
}
